<template>
    <div>
        <el-dialog :title="titleName" :visible.sync="dialogFormVisible" class="qazqaz" width="100%"
                   :close-on-click-modal="false">
            <div class="viewVcloud-main-body-B container">
                <div id="mainbodyVouchers" class="page-wrap">
                    <form id="vouchersForm" class="form-inline">
                        <div class="titlebread" style="height: 56px;">
                            <div class="pull-right">

                                <el-dropdown v-if="!pzVisible && pzIsJieZhang" split-button type="primary"
                                             @click="handleMbClick(1)" size="medium" class="ccc">
                                    凭证模版
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleMbClick(2)">保存为模版</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleMbClick(1)">模版中加载</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <a style="margin-right: 20px;vertical-align: bottom;cursor: pointer;padding-top: 10px;"
                                   @click="openJsq()">
                                    <svg t="1733469833549" class="icon" viewBox="0 0 1024 1024" version="1.1" width="25"
                                         height="25">
                                        <path d="M752.550199 6.490101c15.741445 40.828636 17.110266 82.058478 4.130064 123.665926-0.354006-42.952669-44.250689-43.896684-75.16717-35.754557L294.939072 94.755476c-17.535073 0-26.267209 8.661335-26.196408 25.960404l0.354006 85.197327c0.070801 10.384162 8.142127 18.762292 18.054281 18.762292l395.54216 0.708011c32.332504 9.60535 57.466895 2.56064 75.403174-21.122329 6.844107 31.789695 8.932739 64.86561 6.254098 99.239546l-9.322145 12.272191c-15.021634-8.802937-30.125869-10.690967-45.312706-5.664088l-63.366987 0.236003-82.601286-0.236003a428.783278 428.783278 0 0 0-105.729647 2.714042 192.154193 192.154193 0 0 0-83.073294-0.472007c-36.025961-7.386915-71.107907-6.136096-105.257639 3.776058l-86.02334-9.204143C182.648523 174.288714 182.565922 87.769767 183.427335 47.318737 184.135346 15.340239 208.325723 6.372099 237.590179 6.254097 409.247452 5.723089 580.904726 5.78209 752.550199 6.490101z"
                                              fill="#7A6D79" p-id="83695"></path>
                                        <path d="M752.550199 6.490101l56.286877 0.826013c21.476334 0.318605 32.179101 12.590796 32.0965 36.816573l-0.354006 262.790093-76.229187-3.422053c2.678642-34.373935 0.590009-67.44985-6.254098-99.239546l-1.416022-74.105154c12.980202-41.607448 11.611381-82.83729-4.130064-123.665926z"
                                              fill="#685E67" p-id="83696"></path>
                                        <path d="M756.680263 130.156027l1.416022 74.105154c-17.936279 23.682969-43.070671 30.727679-75.403174 21.122329 17.464272-44.840698 17.074866-88.501378-1.180018-130.98204 30.916481-8.142127 74.813165-7.198112 75.16717 35.754557z"
                                              fill="#28D1B3" p-id="83697"></path>
                                        <path d="M681.513093 94.40147c18.254884 42.480662 18.64429 86.141342 1.180018 130.98204l-395.54216-0.708011c-9.912154 0-17.98348-8.37813-18.054281-18.762292l-0.354006-85.197327c-0.070801-17.299069 8.661335-25.960404 26.196408-25.960404L681.513093 94.40147z"
                                              fill="#89E7CF" p-id="83698"></path>
                                        <path d="M764.350383 303.500727l76.229187 3.422053c0.554609 210.751282 0.708011 421.549765 0.472007 632.371849 0 60.534943-17.582274 90.153404-84.017308 74.695163 6.454701-27.211224 6.926708-54.280845 1.416022-81.185264a1032.339078 1032.339078 0 0 0 2.478039-218.775408 117.128624 117.128624 0 0 0 0-59.000919l3.422053-79.179233-3.422053-59.472926c5.192081-25.641799 5.192081-51.212798 0-76.701194 7.245313-26.97522 6.254097-53.525634-2.950046-79.651241 6.537302-15.41104 5.546086-30.16127-2.950046-44.250689l9.322145-12.272191z"
                                              fill="#698D97" p-id="83699"></path>
                                        <path d="M183.663339 306.92278l86.02334 9.204143c-37.642586 66.907042 69.385081 51.684805 99.239545 50.386785a11.398978 11.398978 0 0 0 9.204144-4.956077c10.93877-16.992265 9.876754-33.39452-3.18605-49.206766 27.777633-5.900092 55.460864-5.734889 83.073294 0.472007-7.858922 15.658844-8.732136 31.47109-2.59604 47.436739 1.27442 3.268651 4.602072 5.428085 8.37813 5.428084 36.934575-0.354006 143.372233 23.718369 99.947557-55.578865l82.601286 0.236003c-35.046546 64.074998 31.034483 56.168875 64.901011 55.106859 16.366855 3.068048 31.943097 1.26262 46.728728-5.428085 9.204143 26.125607 10.195359 52.67602 2.950046 79.651241l-43.778682-2.478039a68.511867 68.511867 0 0 0-34.456537 2.006031 11.328176 11.328176 0 0 0-7.434116 7.552118c-10.454963 35.483153-1.604825 60.888948 26.550414 76.229187 23.293563 3.941261 42.99987 1.734627 59.118921-6.608103l3.422053 59.472926a110.190116 110.190116 0 0 0-50.150781 0 69.703686 69.703686 0 0 0-29.382458 1.062017c-3.894061 0.991215-6.619903 4.059263-6.608103 7.434116v66.081029c0 3.681657 3.056248 6.667104 6.844107 6.726105l32.0965 0.354005 43.778682-2.478039a117.128624 117.128624 0 0 1 0 59.000919c-17.617674-6.761505-42.952669-8.094926-75.993184-4.012062a868.469926 868.469926 0 0 0-7.788121 210.987286 9.097942 9.097942 0 0 0 6.018093 8.024125c12.8268 4.48407 24.473581 5.428085 34.928544 2.832044l40.356629 0.944015c5.510686 26.904419 5.038678 53.974041-1.416022 81.185264-273.127054 2.053232-450.413015 2.206634-531.834283 0.472007-27.683231-0.542808-41.572047-16.119051-41.654649-46.728727-0.62541-220.26223-0.590009-440.536261 0.118002-660.810292z m256.18199 130.274029a77.326604 77.326604 0 0 0-32.332504 1.416022 7.670119 7.670119 0 0 0-5.78209 7.552118v64.192999c-0.0118 3.976662 2.442638 7.257113 5.664089 7.552118l25.960404 2.360037c14.242822 7.08011 29.665662 6.808706 46.25672-0.826013a9.451947 9.451947 0 0 0 5.78209-8.378131l1.770028-62.894979a8.566933 8.566933 0 0 0-5.664088-8.260129c-13.369608-4.956077-27.258425-5.852891-41.654649-2.714042zM282.076872 523.810158l54.516849-0.590009c3.304051 0 6.277698-2.961846 7.08011-7.080111a205.087194 205.087194 0 0 0 2.360037-71.981121c-0.554609-3.740658-3.445654-6.525502-6.844107-6.608103l-35.046546-0.354005a67.803856 67.803856 0 0 0-34.338534 2.006031 11.351777 11.351777 0 0 0-7.316114 7.67012c-9.121542 31.081684-2.59604 56.723483 19.588305 76.937198z m261.020065-6.962109c21.641537 7.552118 44.451292 9.60535 68.441066 6.136096a8.732136 8.732136 0 0 0 7.316114-6.490101c5.746689-24.37918 6.454701-48.923562 2.124033-73.633147a7.198112 7.198112 0 0 0-6.962109-6.018094l-35.518553 0.354006-30.326472 0.472007c-3.292251 0.047201-6.254097 2.997247-7.08011 7.080111a152.15157 152.15157 0 0 0 2.006031 72.099122zM304.143215 657.50624l34.220533-0.472007c1.628425 0 3.18605-0.708011 4.342468-2.006032a7.268913 7.268913 0 0 0 1.793628-4.838075l0.590009-68.323064c0.094401-3.705258-2.501639-6.832306-5.900092-7.08011l-41.418645-2.478039-27.61243 3.540055a7.611119 7.611119 0 0 0-6.608103 7.552118v64.193c-0.0118 3.445654 2.56064 6.643503 6.3721 7.906123a65.609022 65.609022 0 0 0 34.220532 2.006031z m141.602206-81.657272l-37.052577 0.472008a6.088895 6.088895 0 0 0-4.413269 1.94703 6.796906 6.796906 0 0 0-1.840829 4.672873l-0.590009 65.727023a7.552118 7.552118 0 0 0 5.900092 7.434116c10.549364 2.666842 21.240331 3.138849 32.0965 1.416022l40.946638-1.534024c3.351252-0.070801 6.029894-3.327652 6.018093-7.316114v-63.720992a9.274944 9.274944 0 0 0-5.546086-8.614134c-11.717582-5.12128-23.553167-5.274682-35.518553-0.472007z m132.752067 0l-31.152485 0.354006c-3.540055 0.070801-6.372099 3.174249-6.372099 6.962108l-0.472007 68.087061a6.254097 6.254097 0 0 0 6.372099 6.372099l31.624492-0.118002 37.052577-0.472007c3.457454 0 6.254097-2.950046 6.254098-6.608103l0.590009-68.205062a7.906123 7.906123 0 0 0-5.78209-7.788122 60.770946 60.770946 0 0 0-38.114594 1.416022zM269.332673 712.849102a151.51436 151.51436 0 0 0-6.136095 70.683101c0.519208 3.622656 3.044447 6.608103 6.490101 7.670119 11.328176 3.469254 22.656353 4.295267 33.984529 2.478039 11.410778 3.705258 22.774355 3.658057 34.102531-0.118002 3.929461-1.30982 6.596303-4.543071 6.608103-8.024125l-0.118002-68.913073c0-3.327652-2.973646-6.242297-6.962108-6.844107-22.101744-3.138849-44.758097-2.124033-67.969059 3.068048z m149.862334 0.708011l-11.446178 0.708011a6.372099 6.372099 0 0 0-6.018094 6.372099v63.720993c0 3.540055 2.395437 6.619903 5.78209 7.434115 10.702767 2.678642 21.476334 3.150649 32.332504 1.416023 13.062803 5.428085 26.31441 5.546086 39.766619 0.354005 3.705258-1.475023 6.112495-4.779074 6.018094-8.260129l-0.826013-67.497051c0.0236-3.445654-2.773043-6.537302-6.726105-7.434116-20.213715-4.956077-39.83742-3.894061-58.882917 3.18605z m152.576377-1.062017l-24.072375 0.236004c-3.740658 0.059001-6.761505 2.666842-6.844107 5.900092l-0.472007 68.559068c0 3.020847 2.938246 5.593287 6.726104 5.900092l24.662385 2.124033c14.242822 3.941261 29.229055 3.18605 44.9587-2.242035 3.599056-1.26262 5.970893-4.49587 5.900092-8.024125l-1.770028-67.497051c-0.047201-3.469254-2.59604-6.549102-6.254097-7.552118-17.063066-4.318867-31.341288-3.457454-42.834667 2.59604zM439.845329 931.860513a92.383639 92.383639 0 0 0 40.120625-2.006031c3.717058-1.050216 6.277698-4.130064 6.254097-7.552118l-0.118002-64.665007a8.34273 8.34273 0 0 0-6.018093-7.788121 81.421268 81.421268 0 0 0-37.288581-2.596041H275.232765a11.800184 11.800184 0 0 0-11.918185 11.682182l-0.236004 62.186969c0 2.950046 1.215419 5.77029 3.363052 7.847122a11.634981 11.634981 0 0 0 8.083126 3.256851l165.320575-0.354006z m138.652159 0l35.754557 0.236004c3.610856 0.0118 6.549102-2.714042 6.608103-6.136096l0.944015-71.745117c0-3.422053-2.867445-6.242297-6.490101-6.3721l-43.306675-1.062016-26.078406 1.29802c-3.079848 0.141602-5.522486 3.622656-5.546086 7.906123l0.118002 66.78904c0.0118 4.000262 2.489839 7.245313 5.664088 7.434116l32.332503 1.652026z"
                                              fill="#7CA2B0" p-id="83700"></path>
                                        <path d="M374.944318 312.350865c13.062803 15.812246 14.12482 32.214502 3.18605 49.206766a11.398978 11.398978 0 0 1-9.204144 4.956077c-29.854465 1.29802-136.882132 16.520257-99.239545-50.386785 34.149732-9.912154 69.231678-11.162974 105.257639-3.776058zM563.747259 310.10883c43.424676 79.297235-63.012981 55.22486-99.947557 55.578865a8.873738 8.873738 0 0 1-8.37813-5.428084c-6.136096-15.965649-5.262882-31.777895 2.59604-47.436739a428.783278 428.783278 0 0 1 105.729647-2.714042z"
                                              fill="#FC9743" p-id="83701"></path>
                                        <path d="M755.028238 315.772918c8.496132 14.089419 9.487348 28.839649 2.950046 44.250689-14.78563 6.690704-30.361873 8.496132-46.728728 5.428085 9.204143-19.659106 8.696735-38.114594-1.534024-55.342862 15.186837-5.026878 30.291072-3.138849 45.312706 5.664088z"
                                              fill="#FB8628" p-id="83702"></path>
                                        <path d="M646.348545 310.344833l63.366987-0.236003c10.230759 17.228268 10.738167 35.683756 1.534024 55.342862-33.866527 1.062017-99.947557 8.96814-64.901011-55.106859z"
                                              fill="#FC9743" p-id="83703"></path>
                                        <path d="M717.149648 437.196809c-3.18605 21.948342 4.130064 77.763211-15.340239 85.787336-28.155238-15.340239-37.005376-40.746035-26.550414-76.229187a11.328176 11.328176 0 0 1 7.434116-7.552118 68.511867 68.511867 0 0 1 34.456537-2.006031z"
                                              fill="#F1EFF2" p-id="83704"></path>
                                        <path d="M717.149648 437.196809l43.778682 2.478039c5.192081 25.488397 5.192081 51.059395 0 76.701194-16.119051 8.34273-35.825358 10.549364-59.118921 6.608103 19.470303-8.024125 12.154189-63.838994 15.340239-85.787336zM764.350383 575.848968l-3.422053 79.179233-43.778682 2.478039-2.950046-81.657272a110.190116 110.190116 0 0 1 50.150781 0z"
                                              fill="#CBE5E6" p-id="83705"></path>
                                        <path d="M714.199602 575.848968l2.950046 81.657272-32.0965-0.354005a6.844107 6.844107 0 0 1-6.844107-6.726105v-66.081029c-0.0118-3.374853 2.714042-6.4429 6.608103-7.434116a69.703686 69.703686 0 0 1 29.382458-1.062017z"
                                              fill="#F1EFF2" p-id="83706"></path>
                                        <path d="M760.92833 714.02912a1032.339078 1032.339078 0 0 1-2.478039 218.775408l-40.356629-0.944015-2.832044-209.33526a7.493117 7.493117 0 0 0-5.900092-7.316114l-24.42638-5.192081c33.040515-4.082864 58.375509-2.749443 75.993184 4.012062z"
                                              fill="#CBE5E6" p-id="83707"></path>
                                        <path d="M684.935146 710.017058l24.42638 5.192081a7.493117 7.493117 0 0 1 5.900092 7.316114l2.832044 209.33526c-10.454963 2.59604-22.101744 1.652026-34.928544-2.832044a9.097942 9.097942 0 0 1-6.018093-8.024125c-5.970893-70.801103-3.374853-141.130198 7.788121-210.987286z"
                                              fill="#F1EFF2" p-id="83708"></path>
                                        <path d="M433.355228 520.270103c7.634719-26.97522 9.794153-54.670251 6.490101-83.073294 14.396224-3.138849 28.285041-2.242035 41.654649 2.714042a8.566933 8.566933 0 0 1 5.664088 8.260129l-1.770028 62.894979a9.451947 9.451947 0 0 1-5.78209 8.378131c-16.591058 7.634719-32.013899 7.906123-46.25672 0.826013z"
                                              fill="#CBE5E6" p-id="83709"></path>
                                        <path d="M304.143215 437.196809c0.354006 25.842402 11.210175 79.061231-22.066343 86.613349-22.184346-20.213715-28.709847-45.855514-19.588305-76.937198a11.351777 11.351777 0 0 1 7.316114-7.67012 67.803856 67.803856 0 0 1 34.338534-2.006031z"
                                              fill="#F1EFF2" p-id="83710"></path>
                                        <path d="M304.143215 437.196809l35.046546 0.354005c3.398453 0.082601 6.289498 2.867445 6.844107 6.608103a205.087194 205.087194 0 0 1-2.360037 71.981121c-0.802412 4.118264-3.776059 7.08011-7.08011 7.080111l-54.516849 0.590009c33.276518-7.552118 22.420349-60.770946 22.066343-86.613349z"
                                              fill="#CBE5E6" p-id="83711"></path>
                                        <path d="M439.845329 437.196809c3.304051 28.403042 1.144618 56.098074-6.490101 83.073294l-25.960404-2.360037c-3.22145-0.295005-5.675888-3.575456-5.664089-7.552118v-64.192999a7.670119 7.670119 0 0 1 5.78209-7.552118 77.326604 77.326604 0 0 1 32.332504-1.416022zM578.497488 437.196809l-0.708011 66.553036c0 3.988462-1.958831 7.493117-5.074079 9.086142-8.802937 4.720074-18.679691 6.065294-29.618461 4.012062a152.15157 152.15157 0 0 1-2.006031-72.099122c0.826013-4.082864 3.787859-7.03291 7.08011-7.080111l30.326472-0.472007z"
                                              fill="#F1EFF2" p-id="83712"></path>
                                        <path d="M578.497488 437.196809l35.518553-0.354006a7.198112 7.198112 0 0 1 6.962109 6.018094 181.427826 181.427826 0 0 1-2.124033 73.633147 8.732136 8.732136 0 0 1-7.316114 6.490101c-23.989774 3.469254-46.799529 1.416022-68.441066-6.136096 10.93877 2.053232 20.815524 0.708011 29.618461-4.012062 3.115249-1.593025 5.074079-5.097679 5.074079-9.086142l0.708011-66.553036z"
                                              fill="#CBE5E6" p-id="83713"></path>
                                        <path d="M297.771116 572.308913c7.398715 27.695031 9.522748 56.098074 6.372099 85.197327a65.609022 65.609022 0 0 1-34.220532-2.006031c-3.811459-1.26262-6.383899-4.460469-6.3721-7.906123v-64.193a7.611119 7.611119 0 0 1 6.608103-7.552118l27.61243-3.540055z"
                                              fill="#F1EFF2" p-id="83714"></path>
                                        <path d="M297.771116 572.308913l41.418645 2.478039c3.398453 0.247804 5.994493 3.374853 5.900092 7.08011l-0.590009 68.323064a7.268913 7.268913 0 0 1-1.793628 4.838075 5.829291 5.829291 0 0 1-4.342468 2.006032l-34.220533 0.472007a231.1302 231.1302 0 0 0-6.372099-85.197327zM439.845329 657.50624l5.900092-81.657272c11.965386-4.790875 23.800971-4.637472 35.518553 0.472008 3.374853 1.439622 5.557887 4.838075 5.546086 8.614134v63.720992c0.0118 4.012062-2.666842 7.257113-6.018093 7.316114l-40.946638 1.534024zM578.497488 657.50624V575.848968a60.770946 60.770946 0 0 1 38.114594-1.416022 7.906123 7.906123 0 0 1 5.78209 7.788122l-0.590009 68.205062c0 3.658057-2.796644 6.608103-6.254098 6.608103l-37.052577 0.472007z"
                                              fill="#CBE5E6" p-id="83715"></path>
                                        <path d="M445.745421 575.848968l-5.900092 81.657272a78.754427 78.754427 0 0 1-32.0965-1.416022 7.552118 7.552118 0 0 1-5.900092-7.434116l0.590009-65.727023c0-1.746427 0.66081-3.422053 1.840829-4.661073a6.088895 6.088895 0 0 1 4.413269-1.93523l37.052577-0.472007zM578.497488 575.848968v81.657272l-31.624492 0.118002a6.254097 6.254097 0 0 1-6.372099-6.372099l0.472007-68.087061c0-3.787859 2.832044-6.891307 6.372099-6.962108l31.152485-0.354006z"
                                              fill="#F1EFF2" p-id="83716"></path>
                                        <path d="M303.671208 793.680361l-1.180018-71.509114a7.021109 7.021109 0 0 0-6.372099-7.08011l-26.786418-2.242035c23.210961-5.192081 45.867314-6.206897 67.969059-3.068048 3.988462 0.601809 6.962108 3.516455 6.962108 6.844107l0.118002 68.913073c-0.0118 3.481054-2.678642 6.714305-6.608103 8.024125-11.328176 3.776059-22.691753 3.82326-34.102531 0.118002zM439.845329 793.208354c-0.708011-13.334208 13.688213-84.72532-20.650322-79.651241 19.045497-7.08011 38.669202-8.142127 58.882917-3.18605 3.953062 0.896814 6.749705 3.988462 6.726105 7.434116l0.826013 67.497051c0.094401 3.481054-2.312836 6.785106-6.018094 8.260129-13.45221 5.192081-26.703816 5.074079-39.766619-0.354005zM571.771384 795.214385c11.257375-28.001836 11.257375-55.578866 0-82.719289 11.493379-6.053494 25.771601-6.914908 42.834667-2.59604 3.658057 1.003016 6.206897 4.082864 6.254097 7.552118l1.770028 67.497051c0.070801 3.528255-2.301036 6.761505-5.900092 8.024125-15.729645 5.428085-30.715878 6.183296-44.9587 2.242035z"
                                              fill="#CBE5E6" p-id="83717"></path>
                                        <path d="M571.771384 712.495096c11.257375 27.140423 11.257375 54.717452 0 82.719289l-24.662385-2.124033c-3.787859-0.306805-6.726105-2.879245-6.726104-5.900092l0.472007-68.559068c0.082601-3.23325 3.103448-5.841091 6.844107-5.900092l24.072375-0.236004zM269.332673 712.849102l26.786418 2.242035a7.021109 7.021109 0 0 1 6.372099 7.08011l1.180018 71.509114c-11.328176 1.817228-22.656353 0.991215-33.984529-2.478039a9.381146 9.381146 0 0 1-6.490101-7.670119 151.51436 151.51436 0 0 1 6.136095-70.683101zM419.195007 713.557113c34.338535-5.074079 19.942311 66.317033 20.650322 79.651241a80.028846 80.028846 0 0 1-32.332504-1.416023 7.611119 7.611119 0 0 1-5.78209-7.434115v-63.720993a6.372099 6.372099 0 0 1 6.018094-6.372099l11.446178-0.708011zM442.795375 847.253195l-2.950046 84.607318L274.524754 932.214518a11.634981 11.634981 0 0 1-8.083126-3.24505 10.91517 10.91517 0 0 1-3.363052-7.835322l0.236004-62.186969a11.800184 11.800184 0 0 1 11.918185-11.682182h167.56261z"
                                              fill="#F1EFF2" p-id="83718"></path>
                                        <path d="M442.795375 847.253195a81.421268 81.421268 0 0 1 37.288581 2.596041c3.587256 1.132818 6.018094 4.283467 6.018093 7.788121l0.118002 64.665007c0.0236 3.422053-2.53704 6.501901-6.254097 7.552118a92.383639 92.383639 0 0 1-40.120625 2.006031l2.950046-84.607318z"
                                              fill="#CBE5E6" p-id="83719"></path>
                                        <path d="M572.007387 846.781188c7.870723 27.695031 10.030156 56.050873 6.490101 85.079325l-32.332503-1.652026c-3.174249-0.188803-5.652288-3.433853-5.664088-7.434116l-0.118002-66.78904c0.0236-4.283467 2.466238-7.764521 5.546086-7.906123l26.078406-1.29802z"
                                              fill="#F1EFF2" p-id="83720"></path>
                                        <path d="M572.007387 846.781188l43.306675 1.062016c3.622656 0.129802 6.490101 2.950046 6.490101 6.3721l-0.944015 71.745117c-0.059001 3.422053-2.997247 6.147896-6.608103 6.136096l-35.754557-0.236004c3.540055-29.028452 1.380622-57.384294-6.490101-85.079325z"
                                              fill="#CBE5E6" p-id="83721"></path>
                                    </svg>
                                </a>
                                <el-button size="small" v-if="!pzVisible && pzIsJieZhang" @click="handleAddPlush()"
                                           style="background: #237de9;border: 1px solid #237de9;color: #fff;">
                                    保存并添加<i class="el-icon-plus"></i></el-button>
                                <el-button size="small" v-if="pzIsJieZhang" @click="handleAdd()"
                                           style="background-color:#e4ecfd;color: #3c4c8a;margin-left: 5px;border: 1px solid #91a9e2;">
                                    保存
                                </el-button>
                                <el-button size="small" @click="dialogFormVisible = false"
                                           style="background-color:red;color: white;margin-left: 5px;border: 1px solid red;">
                                    取 消
                                </el-button>
                                <span class="lightblue-btn small-btn glyphicon glyphicon-retweet togglebtn isNotAdd"
                                      style="top: 0px; display: none;"></span>
                            </div>
                            <div class="voucher_tit">
                                <h1>记账凭证</h1>
                                <span class="vch_year_month" style="display: none;">xxxx-xx</span> <span></span>
                            </div>
                            <div class="forV">
                                <span class="serialNum">
                                    <span style="margin-right: 5px;">凭证字</span>
                                    <el-select v-model="pzz" size="small"
                                               style="width: 66px;background-color: #ffffff;margin-right: 6px;">
                                        <el-option v-for="item in pzzList" :label="item.pzz"
                                                   :value="item.pzz"></el-option>
                                    </el-select>
                                    <el-input size="small" style="width: 96px;background-color: #eee;" :disabled="true"
                                              v-model="pzh"></el-input>
                                    <span style="margin-left: 5px;">号</span>
                                </span>
                                <label style="margin-left: 20px;">日期 ：</label>
                                <div class="input-group input-append date form_datetime_v">
                                    <el-date-picker size="small" :picker-options="pickerOptions" style="width: 136px;"
                                                    @change="pzDateChangeFn"
                                                    v-model="pzDate" value-format="yyyy-MM-dd" type="date"
                                                    placeholder="选择日期"/>
                                </div>
                            </div>
                            <div id="tag"></div>
                        </div>
                        <div class="form" style="margin-left: -30px;">
                            <table class="table table-striped v-table" id="voucherTable">
                                <colgroup>
                                    <col width="30">
                                    <col width="">
                                    <col width="349">
                                    <col width="219">
                                    <col width="219">
                                </colgroup>
                                <thead>
                                <tr>
                                    <th class="table-edge"></th>
                                    <th style="vertical-align: middle;">
                                        <strong style="font-size: 13.5px;">摘要</strong>
                                    </th>
                                    <th style="vertical-align: middle;">
                                        <strong style="font-size: 13.5px;">会计科目</strong>
                                    </th>
                                    <th style="vertical-align: middle;">
                                        <strong style="font-size: 13.5px;">借方金额</strong>
                                        <div class="money_unit">
                                            <span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span>
                                            <span>千</span> <span>百</span> <span>十</span> <span>元</span> <span>角</span>
                                            <span class="last">分</span>
                                        </div>
                                    </th>
                                    <th>
                                        <strong style="font-size: 13.5px;">贷方金额</strong>
                                        <div class="money_unit">
                                            <span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span>
                                            <span>千</span> <span>百</span> <span>十</span> <span>元</span> <span>角</span>
                                            <span class="last">分</span>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td class="table-edge"></td>
                                    <td colspan="2" class="heji" style="vertical-align: middle;">
                                        <strong id="hja">&nbsp;&nbsp;合计：<span id="hejizw"></span></strong>
                                        <span v-if="xjlList.length > 0" style="float: right;margin-right: 50px;">
                                            <a @click="xjlClick"
                                               style="color: #4c7ef7;cursor: pointer;text-decoration: underline">现金流</a>
                                        </span>
                                    </td>
                                    <td class="v-money"></td>
                                    <td class="v-money"></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </form>
                </div>
                <!-- 凭证页面 -->
                <div class="div-ui"></div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="openSelect" class="common-dialog" width="90%" append-to-body>
            <div slot="title" class="dialog-title">
                <el-row>
                    <span class="dialog-title-text" style="font-size: 16px;">[指定科目现金流向]</span>
                    <span class="dialog-title-text"
                          style="color: red;font-size: 12px;margin-left: 10px;">{{titleName2}}</span>
                </el-row>
            </div>
            <el-table
                    id="elTableIdWW"
                    :data="xjlList"
                    border
                    size="mini"
                    style="width: 100%">
                <el-table-column label="摘要记录" :render-header="addRedStar">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.zyJl" size="mini" disabled/>
                    </template>
                </el-table-column>
                <el-table-column label="凭证科目" width="390" :render-header="addRedStar">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.kmmc+'['+scope.row.kmdm+']'" size="mini" disabled/>
                    </template>
                </el-table-column>
                <el-table-column label="现金流表统计项" :render-header="addRedStar">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.itemCode" style="width: 100%;text-align: left" size="mini"
                                   filterable clearable
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in itemList"
                                    :key="item.id"
                                    v-if="item.tjPatternCode=='1' || item.tjPatternCode==''"
                                    :disabled="item.tjPatternCode==''"
                                    :label="item.itemCode+' '+ item.itemName"
                                    :value="item.itemCode">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="现金流金额(元)" width="156" :render-header="addRedStar">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.xjlJe" size="mini" @change="inputChange(scope.row.id,'xjlJe')"
                                  :rowId="scope.row.id" tp="xjlJe" onkeyup="value=value.replace(/[^\d.]/g,'')"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="115.6">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-delete" @click="deleteRow(scope.row.id)"
                                   style="color: #dd4f51">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="selectOk">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="fzHsVisible" class="common-dialog" width="30%" append-to-body @close="closeFzHs">
            <div slot="title" class="dialog-title">
                <el-row>
                    <span class="dialog-title-text" style="font-size: 16px;">[辅助核算项目]</span>
                </el-row>
            </div>

            <el-table
                    id="elTableIdWW2"
                    :data="ftList"
                    border
                    size="mini"
                    :show-header="false"
                    style="width: 100%;margin-bottom: 10px">
                <el-table-column label="辅助类型" width="123">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            <span style="color:red;">*</span>
                            {{scope.row.fna}}：
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="类型值" :render-header="addRedStar">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.selectXmFco" style="width: 100%;text-align: left" size="mini"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in scope.row.xmItemList"
                                    :label="item.fna"
                                    :value="item.fco">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table>

            <!--<div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="fzHsVisible = false">确 定</el-button>
            </div>-->

        </el-dialog>

        <mblist v-if="mbListVisible" ref="mblist" @handleSelectMb="handleSelectMb"></mblist>
        <jsq v-if="jsqVisible" ref="jsqref"></jsq>
    </div>

</template>

<script>
    import $ from 'jquery'
    import "@/plugins/pingzheng/stylecopy.css";
    import Mblist from './mblist'
    import Jsq from './jsq'

    export default {
        components: {
            Mblist,
            Jsq
        },
        data() {
            return {
                dialogFormVisible: true,
                mbListVisible: false,
                jsqVisible: false,
                openSelect: false,
                fzHsVisible: false,
                titleName: '',
                titleName2: '',
                editVisible: false,
                pzVisible: false,
                pzIsJieZhang: true,
                pzDate: null,
                pzh: "",
                pzz: "",
                pzId: null,
                startTime: null,
                xjlList: [],
                pzzList: [],
                itemList: [],
                endTime: Date.now(),
                mbForm: {
                    sta: '0',
                    mbna: '',
                    pinJieCanShu: ''
                },
                ftList: [],
                rowDataId: ''

            };
        }, computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        return time.getTime() > new Date(_this.endTime) || time.getTime() < new Date(_this.startTime) - 24 * 3600 * 1000;
                    },
                }
            }
        },
        methods: {
            int(id, type) {

                this.xjlList = [];
                this.ftList = [];
                this.rowDataId = '';

                this.mbForm.mbna = ''
                this.mbForm.pinJieCanShu = ''

                this.dialogFormVisible = true;
                this.pzVisible = false;
                this.pzIsJieZhang = true;

                this.pzDate = null;
                this.startTime = null;
                this.pzh = '';
                this.pzId = null;

                this.searchItemList('report_xjllb');
                this.getPzzList();

                if (type == 0) {
                    this.titleName = "新增凭证";
                    this.url = "/business/pingZheng/save";
                    this.getPzOtherDate();
                    this.$nextTick(() => {
                        this.initAdd();
                        $("tfoot .v-money").html('<div class="v-data">000</div>');
                        $("tfoot .v-money").css("color", "#39f");
                    })
                } else {

                    if (type == 1) {
                        this.pzVisible = true;
                        this.titleName = "修改凭证";
                        this.url = "/business/pingZheng/update";
                    } else if (type == 2) {
                        this.getPzOtherDate();
                        this.titleName = "复制新增";
                        this.url = "/business/pingZheng/save";
                    } else if (type == 3) {
                        this.getPzOtherDate();
                        this.titleName = "新增冲红凭证";
                        this.url = "/business/pingZheng/save";
                    }

                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/pingZheng/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        let json = r.data.data;
                        if (json) {
                            if (type == 1) {
                                this.pzDate = json.pzDate;
                                this.startTime = json.startTime;
                                this.endTime = json.endTime;
                                this.pzh = json.pzhStr;
                                this.pzId = json.id;
                                this.pzz = json.pzz;

                                if (json.isNrjz == '1') {
                                    this.pzIsJieZhang = false;
                                }
                            }

                            this.xjlList = json.xjlList;
                            let array = json.childList;

                            if (type == 3) {
                                array.forEach(item => {
                                    if (item.jfje != null) {
                                        item.jfje = 0 - item.jfje;
                                    }
                                    if (item.dfje != null) {
                                        item.dfje = 0 - item.dfje;
                                    }
                                });
                            }

                            $("#voucherTable tbody").empty();
                            for (let i = 0; i < array.length; i++) {
                                this.vdEdit(array[i]);
                            }
                            //结算合计
                            this.jieDaiMoney();
                        }
                    })
                }
            },
            inputChange(id, filed) {
                let input = $("#elTableIdWW .el-table__body-wrapper tbody").find("input[rowId='" + id + "'][tp='" + filed + "']");
                if (input.val() == '') {
                    input.val(0)
                }
                //去掉左右空格
                let val = Number($.trim(input.val()));
                input.val(val);
                this.xjlList.forEach(item => {
                    if (item.id == id) {
                        item[filed] = val;
                    }
                })
            },
            deleteRow(id) {
                this.xjlList = this.xjlList.filter(item => {
                    return item.id != id;
                })
            },
            selectOk() {
                let bool = false;
                this.xjlList.forEach(item => {
                    if (!item.itemCode) {
                        this.titleName2 = " 提示：请选择科目" + item.kmdm + "现金流向统计项！"
                        bool = true;
                        return false;
                    }
                })
                this.openSelect = bool;
            },
            initAdd() {
                $("#voucherTable tbody").empty();
                for (let i = 0; i < 6; i++) {
                    this.vdAdd(null);
                }
            },
            vdAdd(obj) {
                let trObj = '<tr class="voucher-tr" data-id="' + (this.getUUID()) + '"><td align="center" class="table-edge"></td><td data-type="brief"></td><td data-type="km" kmCode="" kmName="" xmCodes="" xmNames=""></td><td data-type="money" class="v-money"></td><td data-type="money" class="v-money v-money2"></td></tr>';
                if (!obj) {
                    $("#voucherTable tbody").append(trObj);
                } else {
                    $(obj).parents(".voucher-tr").after(trObj);
                }
                this.eventObj();
            },
            vdEdit(dataObj) {
                let trObj = '' +
                    '<tr class="voucher-tr" data-id="' + (dataObj.id) + '">' +
                    '<td align="center" class="table-edge"></td>' +
                    '<td data-type="brief">' + (dataObj.zyJl == null ? '' : dataObj.zyJl) + '</td>' +
                    '<td data-type="km" kmCode="' + (dataObj.kmdm == null ? '' : dataObj.kmdm) + '" kmName="' + (dataObj.kmmc == null ? '' : dataObj.kmmc) + '" xmCodes="' + (dataObj.xmCodes == null ? '' : dataObj.xmCodes) + '" xmNames="' + (dataObj.xmNames == null ? '' : dataObj.xmNames) + '">' + (dataObj.kmdm == null ? '' : dataObj.kmdm) + ' ' + (dataObj.kmmc == null ? '' : dataObj.kmmc) + (dataObj.xmNames == null ? '' : dataObj.xmNames) + '</td>' +
                    '<td data-type="money" class="v-money' + (dataObj.jfje < 0 ? ' color_red' : '') + '">' + (dataObj.jfje == null ? '' : ('<div class="v-data">' + (dataObj.jfje < 0 ? Math.abs(dataObj.jfje) : dataObj.jfje) + '</div>')) + '</td>' +
                    '<td data-type="money" class="v-money v-money2' + (dataObj.dfje < 0 ? ' color_red' : '') + '">' + (dataObj.dfje == null ? '' : ('<div class="v-data">' + (dataObj.dfje < 0 ? Math.abs(dataObj.dfje) : dataObj.dfje) + '</div>')) + '</td>' +
                    '</tr>';
                $("#voucherTable tbody").append(trObj);
                this.eventObj();
            },
            // 给表头加必填符号*
            addRedStar(h, {column}) {
                return [
                    h("span", {style: "color: red"}, "*"),
                    h("span", " " + column.label),
                ];
            },
            eventObj() {
                $(".voucher-tr").off();
                $(".voucher-tr").hover(
                    function () {
                        $(this).find(".table-edge").empty();
                        let ul = '<ul class="operatebtn"><li class="img-plus-sign vd-add" onclick="vdAdd(this);"></li><li class="img-minus-sign vd-remove" onclick="vdRemove(this)"></li></ul>'
                        $(this).find(".table-edge").append(ul);
                    },
                    function () {
                        $(this).find(".table-edge").empty();
                    }
                );
                //金额点击事件
                $("tbody .v-money").off();
                $("tbody .v-money").click(function () {
                    if ($(this).find(".v-data").length && $(this).find(".v-data").length > 0) {
                        let valuedate = $(this).find(".v-data").text() / 100;

                        //负数标红
                        let hasClass = $(this).hasClass("color_red");
                        if (hasClass) {
                            valuedate = 0 - valuedate;
                            $(this).removeClass("color_red");
                        }

                        let input = '<div class="text-auto-wrap"><input class="text-auto" style="text-align: center" onkeyup="num(this)" value="' + valuedate + '"></div>';
                        $(this).empty();
                        $(this).append(input);

                        //指定贯标最右边定位
                        let inputFocus = $(this).find(".text-auto");
                        let val = inputFocus.val();
                        inputFocus.focus();
                        inputFocus.val('');
                        inputFocus.val(val);
                        //inputFocus.select();

                        $(this).find(".text-auto").blur(function () {
                            let valuedate = $(this).val();
                            let parenttd = $(this).parents(".v-money");
                            if (valuedate == null || valuedate == "") {
                                parenttd.empty();
                                parenttd.removeClass("color_red");
                            } else {
                                let vstr;
                                if (String(valuedate).indexOf(".") > -1) {
                                    if (String(valuedate).split(".")[1].length == 1) {
                                        vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1] + "0";
                                    } else if (String(valuedate).split(".")[1].length == 2) {
                                        vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1];
                                    } else if (String(valuedate).split(".")[1].length > 2) {
                                        vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1].substring(0, 2);
                                    } else {
                                        vstr = valuedate;
                                    }
                                } else {
                                    vstr = valuedate + "00";
                                }

                                if (vstr < 0) {
                                    vstr = Math.abs(vstr);
                                    //负数标红
                                    parenttd.addClass("color_red");
                                } else {
                                    parenttd.removeClass("color_red");
                                }

                                let data = '<div class="v-data">' + vstr + '</div>';
                                parenttd.empty();
                                parenttd.append(data);
                            }
                            //结算合计
                            jieDaiMoney();
                        });

                    } else {
                        if ($(this).find(".text-auto").length && $(this).find(".text-auto").length > 0) {

                            //指定贯标最右边定位
                            /*let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);*/
                            //inputFocus.select();

                        } else {
                            let input = '<div class="text-auto-wrap"><input class="text-auto" style="text-align: center" onkeyup="num(this)" value=""></div>';
                            $(this).empty();
                            $(this).append(input);

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            //inputFocus.select();

                            $(this).find(".text-auto").blur(function () {
                                let valuedate = $(this).val();
                                let parenttd = $(this).parents(".v-money");
                                if (valuedate == null || valuedate == "") {
                                    parenttd.empty();
                                } else {
                                    let vstr;
                                    if (String(valuedate).indexOf(".") > -1) {
                                        if (String(valuedate).split(".")[1].length == 1) {
                                            vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1] + "0";
                                        } else if (String(valuedate).split(".")[1].length == 2) {
                                            vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1];
                                        } else if (String(valuedate).split(".")[1].length > 2) {
                                            vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1].substring(0, 2);
                                        } else {
                                            vstr = valuedate;
                                        }
                                    } else {
                                        vstr = valuedate + "00";
                                    }

                                    if (vstr < 0) {
                                        vstr = Math.abs(vstr);
                                        //负数标红
                                        parenttd.addClass("color_red");
                                    } else {
                                        parenttd.removeClass("color_red");
                                    }

                                    let data = '<div class="v-data">' + vstr + '</div>';
                                    parenttd.empty();
                                    parenttd.append(data);
                                }
                                //结算合计
                                jieDaiMoney();
                            });
                        }
                    }
                });

                //摘要点击事件
                $("td[data-type='brief']").off();
                $("td[data-type='brief']").click(function () {
                    $(this).addClass("v-edit");
                    if ($(this).text() != "" && $(this).text() != null) {
                        let valuedate = $(this).text();
                        let input = '<div class="text-auto-wrap"><input class="text-auto" onkeyup="zyChange(this)" value="' + valuedate + '"></div>';
                        $(this).empty();
                        $(this).append(input);

                        $(this).find("input").keyup(function () {
                            $("input").css("background-color", "#D6D6FF");
                        });

                        //指定贯标最右边定位
                        let inputFocus = $(this).find(".text-auto");
                        let val = inputFocus.val();
                        inputFocus.focus();
                        inputFocus.val('');
                        inputFocus.val(val);
                        inputFocus.select();
                        initZySelect(inputFocus)

                        $(this).find(".text-auto").blur(function () {
                            let valuedate = $.trim($(this).val());
                            let parenttd = $(this).parents("td[data-type='brief']");
                            if (valuedate == null || valuedate == "") {
                                parenttd.empty();
                            } else {
                                parenttd.empty();
                                parenttd.text(valuedate);
                            }
                            parenttd.removeClass("v-edit");
                            $(".div-ui").hide();
                        });

                    } else {
                        if ($(this).find(".text-auto").length && $(this).find(".text-auto").length > 0) {
                            $(this).find(".text-auto").focus();
                        } else {
                            let input = '<div class="text-auto-wrap"><input class="text-auto" onkeyup="zyChange(this)" value=""></div>';
                            $(this).empty();
                            $(this).append(input);

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            inputFocus.select();
                            initZySelect(inputFocus)

                            $(this).find(".text-auto").blur(function () {
                                let valueDate = $.trim($(this).val());
                                let parentTd = $(this).parents("td[data-type='brief']");
                                if (valueDate == null || valueDate == "") {
                                    parentTd.empty();
                                } else {
                                    parentTd.empty();
                                    parentTd.text(valueDate);
                                }
                                parentTd.removeClass("v-edit");
                                $(".div-ui").hide();
                            });
                        }
                    }
                });

                //科目点击事件
                $("td[data-type='km']").off();
                $("td[data-type='km']").click(function () {
                    $(this).addClass("v-edit");
                    if ($(this).text() != "" && $(this).text() != null) {
                        let valueDate = $(this).text();
                        km_f($(this), valueDate);
                    } else {
                        if ($(this).find(".text-auto").length && $(this).find(".text-auto").length > 0) {

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            inputFocus.select();

                        } else {
                            km_f($(this), "");
                        }
                    }
                    //添加科目选者框
                    initSelect($(this));
                });
            },
            initSelect(clickObj) {
                let div = '';

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getDicKmByLikeCodeOrName'),
                    method: 'post',
                    data: {dicCodeOrName: $.trim(clickObj.find(".text-auto").val())}
                }).then(r => {
                    $.each(r.data.data, function (i, obj) {
                        div += '<div class="div-li" fzListSize ="' + obj.fzObjList.length + '" kmCode="' + obj.dicCode + '" kmName="' + obj.fullName + '" >' + obj.dicCode + ' ' + obj.fullName + '</div>';
                    });

                    $(".div-ui").show();

                    $(".div-ui").empty();
                    $(".div-ui").append(div);
                    $(".div-ui").width(clickObj.innerWidth() - 2);
                    $(".div-ui").offset({top: clickObj.offset().top + clickObj.innerHeight()});
                    $(".div-ui").offset({left: clickObj.offset().left});

                    $(".div-li").hover(
                        function () {
                            $(this).addClass("hover");
                        },
                        function () {
                            $(this).removeClass("hover");
                        }
                    );

                    $(".div-li").on("mousedown", function () {

                        let dicCode = $(this).attr("kmCode");
                        let xmCodes = clickObj.attr("xmCodes");

                        clickObj.text($(this).text());
                        clickObj.attr("kmCode", dicCode);
                        clickObj.attr("kmName", $(this).attr("kmName"));

                        let fzListSize = $(this).attr("fzListSize");
                        if (fzListSize > 0) {
                            clickObj.removeClass("v-edit");
                            $(".div-ui").hide();
                            let dataId = clickObj.parents(".voucher-tr").attr("data-id");
                            openFzHs(r.data.data, dicCode, dataId, xmCodes);
                        } else {
                            clickObj.attr("xmCodes", "");
                            clickObj.removeClass("v-edit");
                            $(".div-ui").hide();
                        }
                    });
                })
            },
            vdRemove(obj) {
                if ($(".voucher-tr").length > 2) {
                    $(obj).parents(".voucher-tr").remove();
                } else {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "至少保留两条分录！"
                    })
                }
                //结算合计
                this.jieDaiMoney();
            },
            getUUID() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
                })
            },
            jieDaiMoney() {
                let jieMoney = 0;
                let daiMoney = 0;
                $.each($("#voucherTable tbody .v-money"), function (i, obj) {
                    if ($(obj).hasClass("v-money2")) {
                        if ($(obj).text() != "" && $(obj).text() != null) {
                            let val = parseFloat($(obj).text());
                            //负数标红转换
                            if ($(obj).hasClass("color_red")) {
                                val = 0 - val;
                            }
                            daiMoney += val;
                        }
                    } else {
                        if ($(obj).text() != "" && $(obj).text() != null) {
                            let val = parseFloat($(obj).text());
                            //负数标红转换
                            if ($(obj).hasClass("color_red")) {
                                val = 0 - val;
                            }
                            jieMoney += val;
                        }
                    }
                });

                if (jieMoney == daiMoney) {
                    $("#hejizw").text(intToChinese(jieMoney));
                    $("#hja").css("color", "");

                    let hj = jieMoney;
                    if (jieMoney == 0) {
                        hj = '000';
                    }

                    if (hj < 0) {
                        hj = 0 - hj;
                        $("tfoot .v-money").css("color", "#f33");
                    } else {
                        $("tfoot .v-money").css("color", "#39f");
                    }
                    $("tfoot .v-money").html('<div class="v-data">' + hj + '</div>');
                    return true;
                } else {
                    $("#hejizw").text("不平");
                    $("#hja").css("color", "#f33");

                    $("tfoot .v-money").html('<div class="v-data">000</div>');
                    $("tfoot .v-money").css("color", "#f33");
                    return false;
                }
            },
            openFzHs(array, dicCode, rowDataId, xmCodes) {
                this.fzHsVisible = true;

                this.ftList = [];
                this.rowDataId = '';

                let xmFcos = xmCodes.split("_");

                A:for (let i = 0; i < array.length; i++) {
                    let obj = array[i];
                    if (obj.dicCode == dicCode) {
                        this.ftList = obj.fzObjList;
                        if (xmCodes) {
                            B:for (let j = 0; j < this.ftList.length; j++) {
                                let tyObj = this.ftList[j];
                                C:for (let q = 0; q < xmFcos.length; q++) {
                                    let xmfco = xmFcos[q];
                                    if (xmfco.startsWith(tyObj.fco)) {
                                        tyObj.selectXmFco = xmfco;
                                        break C;
                                    }
                                }
                            }
                        }
                        this.rowDataId = rowDataId;
                        break;
                    }
                }
            },
            closeFzHs() {

                let canClose = true;
                let val = "";
                let name = "";

                for (let i = 0; i < this.ftList.length; i++) {
                    let e = this.ftList[i];
                    if (!e.selectXmFco) {
                        canClose = false;
                    } else {
                        if (i == (this.ftList.length - 1)) {
                            val += e.selectXmFco
                        } else {
                            val += e.selectXmFco + "_"
                        }
                        let xmItemList = e.xmItemList;
                        for (let j = 0; j < xmItemList.length; j++) {
                            if (xmItemList[j].fco == e.selectXmFco) {
                                name += "_" + xmItemList[j].fna;
                            }
                        }
                    }
                }

                if (!canClose) {
                    this.$message({
                        type: 'error',
                        message: '请选择辅助核算项目！'
                    })
                    this.fzHsVisible = true;
                    return;
                }

                let tdKm = $("tr[data-id='" + this.rowDataId + "']").find("td[data-type='km']");
                tdKm.attr("xmCodes", val);
                tdKm.attr("xmNames", name);
                tdKm.text(tdKm.text() + name);
                this.fzHsVisible = false;
            },
            intToChinese(n) {
                n += '';
                if (!/^(-?[0-9]\d*)$/.test(n))
                    return "——";
                if (n * 1 == 0) {
                    return '零元整';
                }
                let fu = "";
                if (n * 1 < 0) {
                    fu = "负";
                    n = n.substring(1);
                }
                let unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
                    str = "";
                unit = unit.substr(unit.length - n.length);
                for (let i = 0; i < n.length; i++)
                    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
                let str1 = str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
                return fu + str1;
            },
            km_f(thisObj, valueDate) {
                let input = '<div class="text-auto-wrap"><input class="text-auto" onkeyup="findKm(this)" value="' + valueDate + '"></div>';
                thisObj.empty();
                thisObj.append(input);

                //指定贯标最右边定位
                let inputFocus = thisObj.find(".text-auto");
                let val = inputFocus.val();
                inputFocus.focus();
                inputFocus.val('');
                inputFocus.val(val);
                inputFocus.select();

                thisObj.find(".text-auto").blur(function () {
                    let valueDate = $.trim($(this).val());
                    let parentTd = $(this).parents("td[data-type='km']");

                    let parentTdValue = parentTd.attr("kmCode") + " " + parentTd.attr("kmName") + parentTd.attr("xmNames");
                    if (valueDate == null || valueDate == "" || valueDate != parentTdValue) {
                        parentTd.empty();
                        parentTd.attr("kmCode", "");
                        parentTd.attr("kmName", "");
                    } else {
                        parentTd.empty();
                        parentTd.text(valueDate);
                    }
                    parentTd.removeClass("v-edit");
                    $(".div-ui").hide();

                });
            },
            findKm(obj) {
                let parentTd = $(obj).parents("td[data-type='km']");
                this.initSelect(parentTd);
            },
            num(obj) {

                //监控补充输入
                if ($(obj).val() == "=") {

                    //清空借、贷金额  借贷只能填写一个
                    let vm = $(obj).parents(".v-money");
                    vm.siblings(".v-money").empty();

                    let jieMoney = 0;
                    let daiMoney = 0;
                    $.each($("tbody .v-money"), function (i, obj) {
                        if ($(obj).hasClass("v-money2")) {
                            if ($(obj).text() != "" && $(obj).text() != null) {
                                daiMoney += parseFloat($(obj).text());
                            }
                        } else {
                            if ($(obj).text() != "" && $(obj).text() != null) {
                                jieMoney += parseFloat($(obj).text());
                            }
                        }
                    });

                    if (vm.hasClass("v-money2")) {
                        //当前是贷方金额
                        $(obj).val((jieMoney - daiMoney) / 100);
                    } else {
                        //当前是借方金额
                        $(obj).val((daiMoney - jieMoney) / 100)
                    }

                } else {

                    obj.value = obj.value.replace(/[^\d.-]/g, ""); //清除"数字"和"."以外的字符
                    obj.value = obj.value.replace(/^\./g, ""); //验证第一个字符是数字
                    obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                    obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                    obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
                    if (obj.value.indexOf(".") > -1) {
                        if (obj.value.split(".")[0].length > 9) {
                            obj.value = obj.value.substring(0, 9) + obj.value.split(".")[1];
                        }
                        if (obj.value.split(".")[0].length > 1 && parseInt(obj.value.split(".")[0].substring(0, 1)) == 0) {
                            obj.value = obj.value.substring(1, obj.value.length);
                        }
                    } else {
                        if (obj.value.length > 9) {
                            obj.value = obj.value.substring(0, 9);
                        }
                        if (obj.value.length > 1 && parseInt(obj.value.substring(0, 1)) == 0) {
                            obj.value = obj.value.substring(1, obj.value.length);
                        }
                    }

                    //清空借、贷金额  借贷只能填写一个
                    let vm = $(obj).parents(".v-money");
                    vm.siblings(".v-money").empty();

                }

            },
            handleAdd() {
                this.toAdd(false);
            },
            handleAddPlush() {
                this.toAdd(true);
            },
            toAdd(isBool) {

                if (!this.jieDaiMoney()) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "账目不平！"
                    })
                    return;
                }

                if (!this.pzh) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "凭证号不能为空！"
                    })
                    return;
                }

                if (!this.pzDate) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "凭证日期不能为空！"
                    })
                    return;
                }

                let pinJieCanShu = "";
                let bool = false;
                let msg = "";
                let tdObj;
                //校验是否存在未填项
                $.each($(".voucher-tr"), function (i, tr) {

                    let tds = $(tr).find("td");

                    let zy = $.trim($(tds[1]).text());//摘要
                    let kudm = $.trim($(tds[2]).attr("kmCode"));//会计科目代码
                    let kumc = $.trim($(tds[2]).attr("kmName"));//会计科目名称
                    let xmCodes = $.trim($(tds[2]).attr("xmCodes"));//辅助核算项目代码
                    let jfje = $.trim($(tds[3]).text());//借方金额
                    let dfje = $.trim($(tds[4]).text());//贷方金额

                    if (!xmCodes) {
                        xmCodes = " ";
                    }

                    if (zy == "" && kudm == "" && jfje == "" && dfje == "") {
                        return;
                    }

                    if (zy == "") {
                        msg = "请填写摘要！";
                        tdObj = $(tds[1]);
                        bool = true;
                        return false;
                    }
                    if (kudm == "") {
                        msg = "请选择科目！";
                        tdObj = $(tds[2]);
                        bool = true;
                        return false;
                    }
                    if (jfje == "" && dfje == "") {
                        msg = "请填写金额！";
                        tdObj = $(tds[3]);
                        bool = true;
                        return false;
                    } else if (jfje != "" && dfje != "") {
                        msg = "不能同时填写借贷金额！";
                        tdObj = $(tds[3]);
                        bool = true;
                        return false;
                    }

                    //负数标红转换
                    if ($(tds[3]).hasClass("color_red")) {
                        jfje = 0 - jfje;
                    }
                    //负数标红转换
                    if ($(tds[4]).hasClass("color_red")) {
                        dfje = 0 - dfje;
                    }

                    //借贷金额标识
                    let biaoshi = "";
                    let biaoShiJinE;

                    if (jfje != "") {
                        biaoshi = "jfje";
                        biaoShiJinE = jfje;//金额单位（分）
                    } else {
                        biaoshi = "dfje";
                        biaoShiJinE = dfje;//金额单位（分）
                    }

                    //数据拼装
                    pinJieCanShu += (zy + "=" + kudm + "=" + kumc + "=" + biaoshi + "=" + biaoShiJinE + "=" + xmCodes + ",");//顺次是:摘要+科目代码+科目名称+借贷金额标识+借贷金额（分）

                });

                if (bool) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: msg
                    })
                    tdObj.click();
                    return false;
                }

                if (!this.pzVisible) {
                    //如果是新增，则刷新凭证号
                    this.getMaxPzh(this.pzDate);
                }

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl(this.url),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': this.pzId,
                        'pzz': this.pzz,
                        'pzh': this.pzh,
                        'pzDate': this.pzDate,
                        xjlList: this.xjlList,
                        pinJieCanShu: pinJieCanShu
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        if (isBool) {
                            this.int(null, 0);
                            this.$emit("handleCurrentChange", 1);
                        } else {
                            this.dialogFormVisible = false;
                            this.$emit("handleCurrentChange", 1);
                        }
                    } else if (res.data.code == 10012) {
                        this.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.openSelect = true;
                                this.xjlList = res.data.data;
                                this.titleName2 = " 提示：" + res.data.msg
                            }
                        });
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            },
            xjlClick() {
                this.openSelect = true;
            },
            getMaxPzh(pzDate) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getMaxPzh'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'pzDate': pzDate
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.pzh = res.data.data;
                    }
                })
            },
            getPzOtherDate() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getPzOtherDate'),
                    method: 'post',
                    data: {}
                }).then(res => {
                    let json = res.data.data;
                    this.pzDate = json.pzDate;
                    this.startTime = json.startTime;
                    this.endTime = json.endTime;
                    this.getMaxPzh(this.pzDate);
                })
            },
            getPzzList() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getPzzList'),
                    method: 'post'
                }).then(res => {
                    this.pzzList = res.data.data;
                    if (this.pzzList.length > 0) {
                        this.pzz = this.pzzList[0].pzz;
                    }
                })
            },
            pzDateChangeFn(val) {
                this.getMaxPzh(val)
            },
            zyChange(thiss) {
                //摘要=号复制上一行摘要
                let val = $(thiss).val();
                if (val == "=") {
                    let thisTr = $(thiss).parents(".voucher-tr");
                    let val = this.getTrZy(thisTr);
                    $(thiss).val(val);
                } else {
                    //添加摘要选者框
                    this.initZySelect($(thiss));
                }
            },
            initZySelect(clickObj) {
                let div = '';

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getZyList'),
                    method: 'post',
                    data: {zy: $.trim(clickObj.val())}
                }).then(r => {
                    $.each(r.data.data, function (i, obj) {
                        div += '<div class="div-li" zy="' + obj.zy + '">' + obj.zy + '（' + obj.kjm + '）</div>';
                    });

                    $(".div-ui").show();

                    $(".div-ui").empty();
                    $(".div-ui").append(div);
                    $(".div-ui").width(clickObj.innerWidth() - 2);
                    $(".div-ui").offset({top: clickObj.offset().top + clickObj.innerHeight()});
                    $(".div-ui").offset({left: clickObj.offset().left});

                    $(".div-li").hover(
                        function () {
                            $(this).addClass("hover");
                        },
                        function () {
                            $(this).removeClass("hover");
                        }
                    );

                    $(".div-li").on("mousedown", function () {
                        clickObj.val($(this).attr("zy"));
                        clickObj.removeClass("v-edit");
                        $(".div-ui").hide();
                    });
                })
            },
            getTrZy(thisTr) {
                //递归获取前一个不为空的摘要
                let prevTr = thisTr.prev();
                if (prevTr == undefined || prevTr == 'undefined') {
                    return "";
                }
                let val = prevTr.find("td[data-type='brief']").text();
                if ($.trim(val) == '') {
                    return this.getTrZy(prevTr);
                } else {
                    return $.trim(val);
                }
            },
            searchItemList(reportCode) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/reportItem/searchItemList"),
                    method: 'post',
                    data: {"reportCode": reportCode}
                }).then(res => {
                    if (res.data.code == 0) {
                        this.itemList = res.data.data;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.data.msg
                        })
                    }
                })
            },
            handleMbClick(val) {
                if (val == 1) {
                    this.mbListVisible = true;
                    this.$nextTick(() => {
                        this.$refs.mblist.int();
                    })
                } else if (val == 2) {
                    this.$prompt('模板名称', '保存模板', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(({value}) => {
                        this.mbForm.mbna = value;
                        this.toMbAdd();
                    })
                }
            },
            handleSelectMb(mbId) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuPzmb/view'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': mbId
                    })
                }).then(r => {
                    let mb = r.data.data;
                    if (mb) {
                        let array = mb.childList;
                        $("#voucherTable tbody").empty();
                        for (let i = 0; i < array.length; i++) {
                            this.vdEdit(array[i]);
                        }
                    }
                })
            },
            toMbAdd() {

                if (!this.mbForm.mbna) {
                    this.$message({
                        type: 'warning',
                        message: "模版名称为空！"
                    })
                    return;
                }

                if (!this.mbForm.sta) {
                    this.$message({
                        type: 'warning',
                        message: "状态未选择！"
                    })
                    return;
                }

                let pinJieCanShu = "";
                let bool = false;
                let msg = "";
                let tdObj;
                //校验是否存在未填项
                $.each($(".voucher-tr"), function (i, tr) {

                    let tds = $(tr).find("td");

                    let zy = $.trim($(tds[1]).text());//摘要
                    let kudm = $.trim($(tds[2]).attr("kmCode"));//会计科目代码
                    let kumc = $.trim($(tds[2]).attr("kmName"));//会计科目名称
                    let xmCodes = $.trim($(tds[2]).attr("xmCodes"));//辅助核算项目代码
                    let jfje = $.trim($(tds[3]).text());//借方金额
                    let dfje = $.trim($(tds[4]).text());//贷方金额

                    //负数标红转换
                    if ($(tds[3]).hasClass("color_red")) {
                        jfje = 0 - jfje;
                    }
                    //负数标红转换
                    if ($(tds[4]).hasClass("color_red")) {
                        dfje = 0 - dfje;
                    }

                    if (!xmCodes) {
                        xmCodes = " ";
                    }

                    if (zy == "" && kudm == "" && jfje == "" && dfje == "") {
                        return;
                    }

                    if (zy == "") {
                        msg = "请填写摘要！";
                        tdObj = $(tds[1]);
                        bool = true;
                        return false;
                    }
                    if (kudm == "") {
                        msg = "请选择科目！";
                        tdObj = $(tds[2]);
                        bool = true;
                        return false;
                    }

                    //借贷金额标识
                    let biaoshi = "";
                    let biaoShiJinE;

                    if (jfje != "") {
                        biaoshi = "jfje";
                        biaoShiJinE = jfje;//金额单位（分）
                    } else {
                        biaoshi = "dfje";
                        biaoShiJinE = dfje;//金额单位（分）
                    }

                    //数据拼装
                    pinJieCanShu += (zy + "=" + kudm + "=" + kumc + "=" + biaoshi + "=" + biaoShiJinE + "=" + xmCodes + ",");//顺次是:摘要+科目代码+科目名称+借贷金额标识+借贷金额（分）

                });

                if (bool) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: msg
                    })
                    tdObj.click();
                    return false;
                }

                this.mbForm.pinJieCanShu = pinJieCanShu;

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/fuZhuPzmb/save"),
                    method: 'post',
                    data: this.$httpTAG.adornData(this.mbForm)
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '模版保存成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })

            },
            openJsq() {
                this.jsqVisible = true;
                this.$nextTick(() => {
                    this.$refs.jsqref.int();
                })
            }
        },
        mounted() {
            window.jieDaiMoney = this.jieDaiMoney;// 方法赋值给window
            window.intToChinese = this.intToChinese;
            window.num = this.num;
            window.vdRemove = this.vdRemove;
            window.vdAdd = this.vdAdd;
            window.initSelect = this.initSelect;
            window.km_f = this.km_f;
            window.findKm = this.findKm;
            window.getMaxPzh = this.getMaxPzh;
            window.zyChange = this.zyChange;
            window.initZySelect = this.initZySelect;
            window.openFzHs = this.openFzHs;
        }
    }
</script>

<style scoped>
    .viewVcloud-main-body-B {
        overflow: hidden;
        overflow-y: auto;
        -o-transition: all 0.2s ease;
        -ms-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        margin: 10px 5px;
        height: 600px;
    }

    .qazqaz >>> .color_red {
        color: red;
    }

    .qazqaz >>> .el-dialog__body {
        padding: 0px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    .common-dialog >>> .el-dialog__body {
        padding: 10px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    .qazqaz >>> .el-button--medium {
        padding: 8.2px 10px !important;
    }

    .qazqaz >>> .ccc {
        margin-right: 100px;
        height: 20px;
    }

    .qazqaz >>> .el-button--primary {
        background-color: #f5bb34 !important;
        border-color: #f5bb34 !important;
    }

    .el-popper >>> .popper__arrow {
        display: none !important;
    }

    .el-popper {
        margin-top: 18px !important;
    }
</style>
